module.exports = __webpack_public_path__ + "img/dashboard-tips.dc1d092e.png";